<script setup>
import ButtonBase from "../general/ButtonBase.vue";
defineProps({ blok: Object });
</script>

<template>
  <!--
    Check if we redirect to an internal or external URL.
    In case of an internal URL, we have to use the cached URL with a '/' in front of it.
    Otherwise we can use the url property.
  -->
  <ButtonBase
    class="text-none elevation-0 bg-primary font-weight-bold mt-4"
    :buttonTitle="blok.buttonText"
    :buttonUrl="
      blok.buttonUrl.url ? blok.buttonUrl.url : '/' + blok.buttonUrl.cached_url
    "
    :rel="blok.buttonUrl?.target === '_blank' ? 'nofollow noreferrer' : ''"
    :target="blok.buttonUrl?.target"
  />
</template>
